import { useState } from 'react';

export const useConversationSettingsDialog = (initialOpen = false) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const openDialog = () => setIsOpen(true);
  const closeDialog = () => setIsOpen(false);

  return {
    isOpen,
    openDialog,
    closeDialog,
  };
};
